var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectors9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 852,
    height: 852,
    viewBox: "0 0 852 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M494.352 33.4464C586.46 49.6875 669.902 97.8589 730.026 169.502L425.263 425.264L494.352 33.4464Z",
    fill: "url(#paint0_linear_90_28)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.333 80.7052C307.331 33.9408 402.216 17.2067 494.325 33.4414L425.264 425.264L226.333 80.7052Z",
    fill: "url(#paint1_linear_90_28)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M823.127 425.958C822.964 519.487 789.856 609.969 729.617 681.515L425.266 425.264L823.127 425.958Z",
    fill: "url(#paint2_linear_90_28)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M730.045 169.523C790.164 241.17 823.12 331.707 823.127 425.236L425.264 425.264L730.045 169.523Z",
    fill: "url(#paint3_linear_90_28)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M494.352 817.082C402.244 833.323 307.358 816.596 226.357 769.837L425.264 425.264L494.352 817.082Z",
    fill: "url(#paint4_linear_90_28)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M730.045 681.005C669.925 752.653 586.487 800.83 494.38 817.077L425.264 425.264L730.045 681.005Z",
    fill: "url(#paint5_linear_90_28)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3964 289.188C83.3852 201.299 145.314 127.49 226.31 80.7197L425.265 425.265L51.3964 289.188Z",
    fill: "url(#paint6_linear_90_28)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3967 561.341C19.408 473.453 19.4046 377.104 51.3873 289.213L425.265 425.264L51.3967 561.341Z",
    fill: "url(#paint7_linear_90_28)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M226.333 769.824C145.335 723.059 83.4004 649.254 51.4055 561.368L425.264 425.265L226.333 769.824Z",
    fill: "url(#paint8_linear_90_28)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_90_28",
    x1: 435.725,
    y1: 177.091,
    x2: 655.239,
    y2: 240.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_90_28",
    x1: 273.756,
    y1: 228.428,
    x2: 482.666,
    y2: 135.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_90_28",
    x1: 676.431,
    y1: 416.798,
    x2: 602.569,
    y2: 634.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_90_28",
    x1: 611.933,
    y1: 257.007,
    x2: 695.883,
    y2: 471.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_90_28",
    x1: 500.313,
    y1: 662.049,
    x2: 272.353,
    y2: 677.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_90_28",
    x1: 623.38,
    y1: 579.88,
    x2: 426.85,
    y2: 699.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_90_28",
    x1: 182.679,
    y1: 371.867,
    x2: 283.233,
    y2: 166.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_90_28",
    x1: 206.116,
    y1: 531.157,
    x2: 186.737,
    y2: 289.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_90_28",
    x1: 355.214,
    y1: 714.399,
    x2: 155.531,
    y2: 470.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9176DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805FDA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectors9);
export default __webpack_public_path__ + "static/media/sectors-9.783331ee8e944768a746e4b89477d35f.svg";
export { ForwardRef as ReactComponent };